<!-- @format -->
<script lang="ts">
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  import { valueGetters } from "~/components/fragment-sets/basic_component/util";
  import ImageCarousel from "./ImageCarousel.svelte";
  import { onMount } from "svelte";
  export let request_store_key: StoresKey;
  export let fragment: Fragment;

  const stores_context = getStoresContext(request_store_key);
  const { locale } = stores_context;
  const { getImage } = valueGetters(stores_context);
  $: fragmentImage = $locale && getImage("image", fragment); //English

  let images = [];
  let activeImageIndex: number;
  let imageEnlargement: boolean = false;
  let document_ele: HTMLDocument;

  const onModalOpen = (e: any) => {
    // Check if the page is loaded from mobile view or not:
    let isMobile = window.matchMedia(
      "only screen and (max-width: 992px)"
    ).matches;
    if (!isMobile) {
      imageEnlargement = true;
      const bodyElem = document.getElementsByTagName("body")[0];
      bodyElem.classList.add("modal-open");

      if (document_ele) {
        images = []
        let imageElem = document_ele.getElementsByClassName("gallery-image");
        for (let index = 0; index < imageElem.length; index++) {
          const element = imageElem[index].currentSrc;
          images.push(element);
        }
        activeImageIndex = images.indexOf(e.target.src);
      }
    }
  };

  const onModalClose = () => {
    imageEnlargement = false;
    activeImageIndex = -1;
    const bodyElem = document.getElementsByTagName("body")[0];
    bodyElem.classList.remove("modal-open");
  };

  // When the component mounts:
  onMount(() => {
    document_ele = document;
  });
</script>

<div class="student-housing-image-container">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <img
    src={fragmentImage.src}
    alt="Gallery image"
    class="gallery-image"
    on:click={() => onModalOpen(event)} />
</div>

{#if imageEnlargement == true}
  <ImageCarousel {images} {activeImageIndex} {onModalClose} />
{/if}

<style lang="scss">
  .student-housing-image-container {
    padding-top: 16px;
  }
  .gallery-image {
    margin-bottom: 10px;
    cursor: pointer;
  }
</style>
